import { render, staticRenderFns } from "./CartPanel.vue?vue&type=template&id=9b2f5522&scoped=true"
import script from "./CartPanel.vue?vue&type=script&lang=js"
export * from "./CartPanel.vue?vue&type=script&lang=js"
import style0 from "./CartPanel.vue?vue&type=style&index=0&id=9b2f5522&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2f5522",
  null
  
)

export default component.exports